import React from 'react';

import { images, data } from '../../constants';
import { SubHeading, MenuItem } from '../../components';

import './Technicians.css';

const TechCard = ({tech: {imgUrl, title, subtitle}}) => (
  <div className='app__tech-card'>
    <img src={imgUrl} alt='tech'/>

    <div className='app__tech-card_content'>
      <p className='p__cormorant' style={{color: '#fff'}}> {title} </p>
      <p className='p__cormorant' > {subtitle} </p>

    </div>
  </div>
)

const Technicians = () => (
  <div className='app__bg app__wrapper section__padding' id='technician'>
    <div className='app__wrapper_info '>
      <SubHeading title='Find your desired technician'/>
      <h1 className='headtext__cormorant'> Technicians </h1>

      <div className='app__tech'>
        {data.technicians.map((tech) => <TechCard tech={tech} key={tech.title} />)}
      </div>

    </div>

    <div className='app__wrapper_img'>
      <img src={images.technicians} alt='technicians'/>
    </div>

  </div>
);

export default Technicians;
